import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m13.053 14.895.126.126a2.247 2.247 0 0 0 3.295-.126"
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M9.895 10.66c-.788-.367-2.084-.342-3.158.287"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M8.285 15.662a6.843 6.843 0 1 1 7.365-7.509"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <circle cx={12.074} cy={12.074} r={0.6} fill="currentColor" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M22 15.158A6.842 6.842 0 1 0 15.158 22c.715-.013 1.972-.271 2.873-1.08m0 0a3.1 3.1 0 0 0 .952-1.58c.562-2.255-4.045-.625-.952 1.58Zm0 0c.478.341 1.14.696 2.033 1.052"
    />
    <circle cx={17.337} cy={12.074} r={0.6} fill="currentColor" />
    <circle
      cx={5.758}
      cy={7.2}
      r={0.6}
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
    <circle
      cx={11.547}
      cy={7.2}
      r={0.6}
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const BipolarIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
